import * as yup from 'yup'

export const addressSchema = yup.object({
	fullname: yup.string().required('El nombre completo es obligatorio'),

	document_type: yup.string().required('El tipo de documento es obligatorio'),

	document: yup
		.number()
		.typeError('Debe ser un número válido')
		.integer('Debe ser un número entero')
		.required('El número de documento es obligatorio'),

	province: yup.string().required('La provincia es obligatoria'),

	city: yup.string().required('La ciudad es obligatoria'),

	neighborhood: yup.string().required('El barrio es obligatorio'),

	street_type: yup.string().required('El tipo de calle es obligatorio'),

	street: yup.string().required('El nombre de la calle es obligatorio'),

	number_home: yup.string().required('El número de vivienda es obligatorio'),

	type_home: yup.string().required('El tipo de vivienda es obligatorio'),

	phone: yup
		.number()
		.typeError('Debe ser un número válido')
		.integer('Debe ser un número entero')
		.test(
			'len',
			'Debe tener exactamente 10 dígitos',
			(val) => val?.toString().length === 10
		)
		.required('El teléfono es obligatorio'),

	additional_references: yup.string().optional(),

	postal_code: yup
		.string()
		.matches(/^\d{6}$/, 'El código postal debe tener 6 dígitos')
		.required('El código postal es obligatorio'),
})

export const customerCreateSchema = yup.object({
	role: yup.mixed<'customer'>().oneOf(['customer'], 'Rol inválido').optional(),

	name: yup.string().required('El nombre es obligatorio'),

	lastname: yup.string().required('El apellido es obligatorio'),

	email: yup
		.string()
		.email('Correo inválido')
		.min(5)
		.max(50)
		.required('El correo es obligatorio'),

	phone: yup
		.number()
		.typeError('Debe ser un número válido')
		.integer('Debe ser un número entero')
		.test(
			'len',
			'Debe tener exactamente 10 dígitos',
			(val) => val?.toString().length === 10
		)
		.required('El teléfono es obligatorio'),

	password: yup
		.string()
		.required('La contraseña es obligatoria')
		.min(8, 'Mínimo 8 caracteres')
		.max(30, 'Máximo 30 caracteres')
		.test(
			'is-strong-password',
			'La contraseña debe incluir mayúsculas, minúsculas, un número y un carácter especial.',
			(value) => {
				if (!value) return false
				const hasUpperCase = /[A-Z]/.test(value)
				const hasLowerCase = /[a-z]/.test(value)
				const hasNumber = /\d/.test(value)
				const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(value)
				return hasUpperCase && hasLowerCase && hasNumber && hasSpecialChar
			}
		),

	address: yup.array().of(addressSchema).optional(),
})

export const UpdateCustomerSchema = yup.object({
	name: yup.string().required('El nombre es obligatorio'),

	lastname: yup.string().required('El apellido es obligatorio'),

	email: yup
		.string()
		.email('Correo inválido')
		.min(5)
		.max(50)
		.required('El correo es obligatorio'),

	phone: yup
		.number()
		.typeError('Debe ser un número válido')
		.integer('Debe ser un número entero')
		.test(
			'len',
			'Debe tener exactamente 10 dígitos',
			(val) => val?.toString().length === 10
		)
		.required('El teléfono es obligatorio'),
})
